<label>Not In RTO</label>
<app-autocomplete-field
    [controlName]="controlName"
    [config]="autoCompleteFieldOptions"
>
</app-autocomplete-field>